<script setup lang="ts">
import PdsIcon from './PdsIcon.vue';

defineProps<{ checked: boolean }>();
</script>

<template>
  <span
    class="flex size-6 shrink-0 items-center justify-center rounded-[8px] border-2"
    :class="
      checked
        ? 'bg-accent border-accent text-accent-encre pds-check-pop'
        : 'bg-carte border-filet-fort'
    "
  >
    <PdsIcon v-if="checked" name="check" :size="16" :stroke="2.5" />
  </span>
</template>

<style>
@keyframes pds-check-pop {
  0% {
    transform: scale(1);
  }
  38% {
    transform: scale(1.18);
  }
  100% {
    transform: scale(1);
  }
}

.pds-check-pop {
  animation: pds-check-pop 220ms ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .pds-check-pop {
    animation: none;
  }
}
</style>
